import React, { useEffect, useState } from 'react'
import TopTitleBar from '../TopTitleBar'
import { BASE_URL, GET_VERIFIER_FORM_DASH, GET_VERIFIER_SESSIONS, USER_TOKEN } from '../../../../Utils/constant'
import Records from './Records'
import API from '../../../../ApiConfig'
import { useSelector } from "react-redux";
import Loader from '../../../../components/Loader'
import { Delay } from '../../../../Utils/helper'
import cogoToast from 'cogo-toast-react-17-fix'
import Pagination from '../Pagination'
import { Icon } from 'react-icons-kit'
import { reload } from 'react-icons-kit/iconic/reload'
import BtnLoader from '../../../../components/BtnLoader'
import { BUTTONS } from '../../../../Utils/Strings'
import useRefreshToken from '../../../../Hooks/usegenerateToken'
import NavLinks from '../../../../components/NavLinks'
import dayjs from 'dayjs'

export default function VerificationData() {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const [search, setSearch] = useState('')
  const User = useSelector(state => state.User)
  const [list, setList] = useState([])
  const [apiData, setApiData] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  useEffect(() => {
    getVerificationList()
  }, [currentPage])
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     getVerificationList()
  //   }, 30000);
  //   return () => clearInterval(intervalId);
  // }, [])
  // useEffect(()=>{
  //   window.setTimeout( function() {
  //     window.location.reload();
  //   }, 10000)
  // },[])

  // tabs
  const [MenuLinks, setMenuLinks] = useState([
    { name: "All", link: 2 },
    { name: "Requested Response", link: 0 },
    { name: "QR Response", link: 1 }
  ])
  const [activeTab, setActiveTab] = useState({ name: "All", link: 2 })
  const [docType, setdocType] = useState(0)
  function handleActiveTab(e) {
    setActiveTab(e)
  }


  async function getVerificationList() {


    // debugger
    setLoading(true)
    await Delay()
    API.get(GET_VERIFIER_SESSIONS + User.id, {
      params: {
        page_number: currentPage
      }
    })
      .then(res => {
        setLoading(false)
        if (res.data.status === 200) {
          let { data } = res.data
          setList(data.items)
          setApiData(data.items)
          setCurrentPage(data.current_page)
          setTotalPages(data.total_pages)
        }
      })
      .catch(err => {
        // console.log(err)
        setLoading(false)
        cogoToast.error(err.response.data.detail)
      })
  }
  function handleSearch(value) {
    if (value.length === 0) setList(apiData)
    else {
      let result = []
      {
        apiData.map(apiItem => {
          const formUuid = Object.keys(apiItem)[0]
          const formData = apiItem[formUuid];
          let temp = formData.filter(item => (item.form_name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || (dayjs.utc(item.data_submission_date).format('DD MMM YYYY').toLocaleLowerCase().includes(value.toLocaleLowerCase()))
          ))
          if (temp.length > 0) result.push({ [formUuid]: temp });
        })
      }

      setList(result)
    }
    setSearch(value)

  }
  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
  }
  const handleRefresh = () => {
    getVerificationList();
  }
  return (
    <>
      <TopTitleBar isChild >
        <h2 className="topTitleBarText"> <span className="secondaryButton1">Verifying Sessions</span></h2>
      </TopTitleBar>
      <Loader isOpen={loading} />
      <section className="table-header6" style={{ justifyContent: "space-between" }}>
        <div className="inputField2">
          <div className="input1">
            <div className="content1">
              <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
              <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
            </div>
          </div>
        </div>
        <div className='refreshLoader'>
          <div className='btn btn-primary' title='Reload Table' onClick={handleRefresh} style={{ marginLeft: "1rem", display: "flex", alignItems: "center" }}>
            <div className={loading ? 'reloadIcon1' : 'reloadIcon'}><Icon icon={reload} size={15} /></div> <span style={{ marginLeft: "7px", fontSize: "12px" }}> Refresh </span> </div>
        </div>
      </section>
      <div className="credentials-table">
        {/* <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} ischangeRequested={false} /> */}
        <Records data={list} refreshList={{}} Loading={loading} />
        <div style={{ margin: "10px" }}>
          <Pagination
            nPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>
      </div>
    </>
  )
}
